import axios from "axios";
import "./missionDetail.css"
import Etb from "../etb/Etb";
import { useContext, useEffect, useState } from "react";
import { StarBorder, StarRate, AccessTime, MyLocation } from "@mui/icons-material"
import { AuthContext } from "../../context/AuthContext";

export default function MissionDetail({ selectedMission, setSelectedMission, missions, setmissions }) {
  const [etbs, setEtbs] = useState([])
  const {user:currentUser, dispatch} = useContext(AuthContext)

  const formatter = new Intl.DateTimeFormat("de-DE", {
    hour: "2-digit",
    minute: "2-digit",
    //second: "2-digit"
  });

  const DeleteHandler = async(e) => {
    e.preventDefault();
    try {
      const res = await axios.delete(`/api/missions/${selectedMission._id}`, { data: {userId: currentUser._id}});
    } catch (err) {
      console.log(err)
    }
    setSelectedMission(null);
    /*try {
      const res = await axios.get("/api/missions/");
      setmissions(res.data.sort((p1,p2) => {
        return new Date(p2.createdAt) - new Date(p1.createdAt)
      }))
    } catch (err) {
      console.log(err)
    }*/
  }

  const CloseHandler = async(e) => {
    e.preventDefault();
    setSelectedMission(null);
  }

  useEffect(() => {
    const fetchEtbs = async () => {
      const res = await axios.get("/api/etb/" + selectedMission._id)
      setEtbs(res.data.sort((p1,p2) => {
        return new Date(p2.createdAt) - new Date(p1.createdAt)
      }))
    }
    fetchEtbs();
  }, [selectedMission._id])

  return (
    <>
    <div className="missionDetailHeader">
      <div className="missionDetailHeaderLeft">
        <div className="missionPrio normal">
          Normal
        </div>
        <div className="priostars">
          <StarRate className="prioRatingStar"/>
          <StarRate className="prioRatingStar" />
          <StarRate className="prioRatingStar" />
          <StarBorder className="prioRatingStar" />
          <StarBorder className="prioRatingStar" />
        </div>
        <div className="stateIcons">

        </div>
        {/*<span>Right: Statechangebutton / Dropdown Button</span>*/}
      </div>
      <div className="missionDetailHeaderRight">
        <div className="">Einsatztagebuch</div>
      </div>
    </div>
    <div className="missionParameter">
      <div className="missionParamterLeft">
        <div className="missionNumbers">
          <div className="missionInternalNumber">1</div>
          <div className="missionExternalNumber">{selectedMission.missionnumber}</div>
        </div>
        <div className="missionTimeKeyword">
          <AccessTime className="missionTimeKeywordIcon" />
          <div className="missionTime">{formatter.format(Date.parse(selectedMission.createdAt))}</div>
          <div className="missionKeyword">{selectedMission.keyword}</div>
        </div>
        <div className="missionLocation">
          <MyLocation className="missionLocationIcon" />
          <div className="missionLocationDetails">
            <div className="citysubcity">
              <div className="missionCity">{selectedMission.city}</div>
              <div className="missionSubcity">{selectedMission.subcity}</div>
            </div>
            <div className="streetstreet2">
              <div className="missionStreet">{selectedMission.street}</div>
              <div className="missionStreet2">{selectedMission.street2}</div>
            </div>
            <div className="missionObject">{selectedMission.object}</div>
          </div>
        </div>
        <div className="missiondesc">Beschreibung</div>
        <div className="missionButtons">
          <div className="missionClose" onClick={CloseHandler}>Schließen</div>
          {currentUser.isAdmin?
            <div className="missionDelete" onClick={DeleteHandler}>Löschen</div>
            :
            ""
          }
        </div>
      </div>
      <div className="missionParameterRight">
        <div className="etbList">
          {etbs.map((p) => (
            <Etb key={p._id} etb={p}/>
          ))}
          </div>
      </div>
    </div>
    <div className="missionmap">
    </div>
    </>
  )
}
